<template>
  <div id="app">
    <Loader v-if="showLoader"/>

    <template v-else>
      <div v-if="!hasToken" class="invalid-token">
        <p class="invalid-token__message">
          There has been an error authenticating your account,
          please logout and back into the application.
        </p>
      </div>

      <div v-if="!isTokenValid" class="invalid-token">
        <p class="invalid-token__message">
          Authorization failed, please check that your token is valid
        </p>
      </div>

      <router-view v-if="isTokenValid"/>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { types } from './store';

import Loader from './components/common/Loader.vue';

export default {
  name: 'app',
  components: {
    Loader,
  },
  watch: {
    showLoader(newStatus) {
      document.documentElement.style.overflow = newStatus ? 'hidden' : 'auto';
    },
  },
  computed: {
    ...mapGetters({
      showLoader: types.GET_SHOW_LOADER,
      hasToken: types.GET_TOKEN,
      isTokenValid: types.GET_IS_TOKEN_VALID,
    }),
  },
  created() {
    this.fetchInitialData(this.$route.query.token);
  },
  methods: {
    ...mapActions({
      fetchInitialData: types.FETCH_INITIAL_DATA,
    }),
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.invalid-token {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
}
.invalid-token__message {
  color: #0A2756;
  font-size: 32px;
  line-height: 1.4;
  text-align: center;
}
</style>
